import { render, staticRenderFns } from "./CampusView.vue?vue&type=template&id=18459061&"
import script from "./CampusView.vue?vue&type=script&lang=js&"
export * from "./CampusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports